export default "/images/menu.svg"